import {
  STRING_getInstance2dgfp43qdvxn4 as STRING_getInstance,
  INT_getInstanceuk3mdpekz01w as INT_getInstance,
  BOOLEAN_getInstance1rr5hmle1nxny as BOOLEAN_getInstance,
  DOUBLE_getInstance2jkrkb6s86ape as DOUBLE_getInstance,
  LONG_getInstance3o159802bm1hf as LONG_getInstance,
  BYTE_getInstance3kusmugh6vx0 as BYTE_getInstance,
  SHORT_getInstance3i0uh78x1nbso as SHORT_getInstance,
  CHAR_getInstance65o9iopcgmw8 as CHAR_getInstance,
  FLOAT_getInstance3odp92qr6pifc as FLOAT_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  Unit_instance28fytmsmm6r23 as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from './ObjectSerializer.mjs';
import { initBuiltins3cd82qqvse108 as initBuiltins } from './Platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
var StringSerializerClass;
function StringSerializer() {
  if (StringSerializerClass === VOID) {
    class $ {
      constructor() {
        StringSerializer_instance = this;
        this.x24_1 = new (PrimitiveSerialDescriptor())('kotlin.String', STRING_getInstance());
      }
      x1m() {
        return this.x24_1;
      }
      y24(encoder, value) {
        return encoder.t1s(value);
      }
      y1m(encoder, value) {
        return this.y24(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.j1r();
      }
    }
    initMetadataForObject($, 'StringSerializer', VOID, VOID, [KSerializer()]);
    StringSerializerClass = $;
  }
  return StringSerializerClass;
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new (StringSerializer())();
  return StringSerializer_instance;
}
var IntSerializerClass;
function IntSerializer() {
  if (IntSerializerClass === VOID) {
    class $ {
      constructor() {
        IntSerializer_instance = this;
        this.z24_1 = new (PrimitiveSerialDescriptor())('kotlin.Int', INT_getInstance());
      }
      x1m() {
        return this.z24_1;
      }
      a25(encoder, value) {
        return encoder.o1s(value);
      }
      y1m(encoder, value) {
        return this.a25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.e1r();
      }
    }
    initMetadataForObject($, 'IntSerializer', VOID, VOID, [KSerializer()]);
    IntSerializerClass = $;
  }
  return IntSerializerClass;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new (IntSerializer())();
  return IntSerializer_instance;
}
var BooleanSerializerClass;
function BooleanSerializer() {
  if (BooleanSerializerClass === VOID) {
    class $ {
      constructor() {
        BooleanSerializer_instance = this;
        this.b25_1 = new (PrimitiveSerialDescriptor())('kotlin.Boolean', BOOLEAN_getInstance());
      }
      x1m() {
        return this.b25_1;
      }
      c25(encoder, value) {
        return encoder.l1s(value);
      }
      y1m(encoder, value) {
        return this.c25(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.b1r();
      }
    }
    initMetadataForObject($, 'BooleanSerializer', VOID, VOID, [KSerializer()]);
    BooleanSerializerClass = $;
  }
  return BooleanSerializerClass;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new (BooleanSerializer())();
  return BooleanSerializer_instance;
}
var DoubleSerializerClass;
function DoubleSerializer() {
  if (DoubleSerializerClass === VOID) {
    class $ {
      constructor() {
        DoubleSerializer_instance = this;
        this.d25_1 = new (PrimitiveSerialDescriptor())('kotlin.Double', DOUBLE_getInstance());
      }
      x1m() {
        return this.d25_1;
      }
      e25(encoder, value) {
        return encoder.r1s(value);
      }
      y1m(encoder, value) {
        return this.e25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.h1r();
      }
    }
    initMetadataForObject($, 'DoubleSerializer', VOID, VOID, [KSerializer()]);
    DoubleSerializerClass = $;
  }
  return DoubleSerializerClass;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new (DoubleSerializer())();
  return DoubleSerializer_instance;
}
var LongSerializerClass;
function LongSerializer() {
  if (LongSerializerClass === VOID) {
    class $ {
      constructor() {
        LongSerializer_instance = this;
        this.f25_1 = new (PrimitiveSerialDescriptor())('kotlin.Long', LONG_getInstance());
      }
      x1m() {
        return this.f25_1;
      }
      g25(encoder, value) {
        return encoder.p1s(value);
      }
      y1m(encoder, value) {
        return this.g25(encoder, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.f1r();
      }
    }
    initMetadataForObject($, 'LongSerializer', VOID, VOID, [KSerializer()]);
    LongSerializerClass = $;
  }
  return LongSerializerClass;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new (LongSerializer())();
  return LongSerializer_instance;
}
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().z4(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer())) ? tmp : THROW_CCE();
}
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().b5();
  var _iterator__ex2g4s = values.u1();
  while (_iterator__ex2g4s.v1()) {
    var primitive = _iterator__ex2g4s.w1();
    var primitiveName = primitive.x1m().a1o();
    if (serialName === primitiveName) {
      throw IllegalArgumentException().s2(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).o1() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new (PrimitiveSerialDescriptor())(serialName, kind);
}
function error($this) {
  throw IllegalStateException().o('Primitive descriptor ' + $this.h25_1 + ' does not have elements');
}
var PrimitiveSerialDescriptorClass;
function PrimitiveSerialDescriptor() {
  if (PrimitiveSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, kind) {
        this.h25_1 = serialName;
        this.i25_1 = kind;
      }
      a1o() {
        return this.h25_1;
      }
      t1p() {
        return this.i25_1;
      }
      v1p() {
        return 0;
      }
      x1p(index) {
        error(this);
      }
      y1p(name) {
        error(this);
      }
      b1q(index) {
        error(this);
      }
      a1q(index) {
        error(this);
      }
      z1p(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.h25_1 + ')';
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrimitiveSerialDescriptor()))
          return false;
        if (this.h25_1 === other.h25_1 && equals(this.i25_1, other.i25_1))
          return true;
        return false;
      }
      hashCode() {
        return getStringHashCode(this.h25_1) + imul(31, this.i25_1.hashCode()) | 0;
      }
    }
    protoOf($).m1p = get_isNullable;
    protoOf($).u1p = get_isInline;
    protoOf($).w1p = get_annotations;
    initMetadataForClass($, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    PrimitiveSerialDescriptorClass = $;
  }
  return PrimitiveSerialDescriptorClass;
}
var ByteSerializerClass;
function ByteSerializer() {
  if (ByteSerializerClass === VOID) {
    class $ {
      constructor() {
        ByteSerializer_instance = this;
        this.j25_1 = new (PrimitiveSerialDescriptor())('kotlin.Byte', BYTE_getInstance());
      }
      x1m() {
        return this.j25_1;
      }
      k25(encoder, value) {
        return encoder.m1s(value);
      }
      y1m(encoder, value) {
        return this.k25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.c1r();
      }
    }
    initMetadataForObject($, 'ByteSerializer', VOID, VOID, [KSerializer()]);
    ByteSerializerClass = $;
  }
  return ByteSerializerClass;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new (ByteSerializer())();
  return ByteSerializer_instance;
}
var ShortSerializerClass;
function ShortSerializer() {
  if (ShortSerializerClass === VOID) {
    class $ {
      constructor() {
        ShortSerializer_instance = this;
        this.l25_1 = new (PrimitiveSerialDescriptor())('kotlin.Short', SHORT_getInstance());
      }
      x1m() {
        return this.l25_1;
      }
      m25(encoder, value) {
        return encoder.n1s(value);
      }
      y1m(encoder, value) {
        return this.m25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.d1r();
      }
    }
    initMetadataForObject($, 'ShortSerializer', VOID, VOID, [KSerializer()]);
    ShortSerializerClass = $;
  }
  return ShortSerializerClass;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new (ShortSerializer())();
  return ShortSerializer_instance;
}
var CharSerializerClass;
function CharSerializer() {
  if (CharSerializerClass === VOID) {
    class $ {
      constructor() {
        CharSerializer_instance = this;
        this.n25_1 = new (PrimitiveSerialDescriptor())('kotlin.Char', CHAR_getInstance());
      }
      x1m() {
        return this.n25_1;
      }
      o25(encoder, value) {
        return encoder.s1s(value);
      }
      y1m(encoder, value) {
        return this.o25(encoder, value instanceof Char() ? value.j4_1 : THROW_CCE());
      }
      p25(decoder) {
        return decoder.i1r();
      }
      z1m(decoder) {
        return new (Char())(this.p25(decoder));
      }
    }
    initMetadataForObject($, 'CharSerializer', VOID, VOID, [KSerializer()]);
    CharSerializerClass = $;
  }
  return CharSerializerClass;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new (CharSerializer())();
  return CharSerializer_instance;
}
var FloatSerializerClass;
function FloatSerializer() {
  if (FloatSerializerClass === VOID) {
    class $ {
      constructor() {
        FloatSerializer_instance = this;
        this.q25_1 = new (PrimitiveSerialDescriptor())('kotlin.Float', FLOAT_getInstance());
      }
      x1m() {
        return this.q25_1;
      }
      r25(encoder, value) {
        return encoder.q1s(value);
      }
      y1m(encoder, value) {
        return this.r25(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      z1m(decoder) {
        return decoder.g1r();
      }
    }
    initMetadataForObject($, 'FloatSerializer', VOID, VOID, [KSerializer()]);
    FloatSerializerClass = $;
  }
  return FloatSerializerClass;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new (FloatSerializer())();
  return FloatSerializer_instance;
}
var UnitSerializerClass;
function UnitSerializer() {
  if (UnitSerializerClass === VOID) {
    class $ {
      constructor() {
        UnitSerializer_instance = this;
        this.s25_1 = new (ObjectSerializer())('kotlin.Unit', Unit_instance);
      }
      x1m() {
        return this.s25_1.x1m();
      }
      t25(encoder, value) {
        this.s25_1.r1n(encoder, Unit_instance);
      }
      y1m(encoder, value) {
        return this.t25(encoder, value instanceof Unit() ? value : THROW_CCE());
      }
      u25(decoder) {
        this.s25_1.z1m(decoder);
      }
      z1m(decoder) {
        this.u25(decoder);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'UnitSerializer', VOID, VOID, [KSerializer()]);
    UnitSerializerClass = $;
  }
  return UnitSerializerClass;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new (UnitSerializer())();
  return UnitSerializer_instance;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
//region block: exports
export {
  BooleanSerializer_getInstance as BooleanSerializer_getInstancei6giaf3o69cd,
  ByteSerializer_getInstance as ByteSerializer_getInstance1w54to3nupb52,
  CharSerializer_getInstance as CharSerializer_getInstance1c1187x3xhckl,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance33stfxil1rcyl,
  FloatSerializer_getInstance as FloatSerializer_getInstancedyjoacse4hez,
  IntSerializer_getInstance as IntSerializer_getInstance3pev8isxtkhc2,
  LongSerializer_getInstance as LongSerializer_getInstance1rq8rtbkqcjan,
  ShortSerializer_getInstance as ShortSerializer_getInstance2zmbb9kqwhwwe,
  StringSerializer_getInstance as StringSerializer_getInstance2hpyx1v3alnih,
  UnitSerializer_getInstance as UnitSerializer_getInstance2lpwg73xwvyu8,
  PrimitiveDescriptorSafe as PrimitiveDescriptorSafe1r3pht5v1oaqu,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptorkwnwsc78b2on,
  builtinSerializerOrNull as builtinSerializerOrNull180kp99qvlpex,
  checkNameIsNotAPrimitive as checkNameIsNotAPrimitive28vmhppr4nskt,
};
//endregion

//# sourceMappingURL=Primitives.mjs.map
